import { List } from "antd";
import styled, { css } from "styled-components";

import DefaultButtonLoadMore from "shared/components/atoms/ButtonLoadMore";

export const ContainerList = styled(List)`
  overflow-y: auto;
  max-height: 280px;
  margin-top: 16px;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #003366;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #003366;
  }

  ${({ theme }) =>
    theme.mode === "dark"
      ? css`
          &::-webkit-scrollbar-thumb {
            background: ${theme.colors.secondary};
          }

          &::-webkit-scrollbar-thumb:hover {
            background: ${theme.colors.secondary};
          }
        `
      : css`
          &::-webkit-scrollbar-thumb {
            background: ${theme.colors.primary};
          }

          &::-webkit-scrollbar-thumb:hover {
            background: ${theme.colors.primary};
          }
        `}

  @media (max-width: 800px) {
    max-height: 54vh;
    min-height: 54vh;
    height: 100%;
    overflow-y: scroll;
  }
`;

export const ButtonLoadMore = styled(DefaultButtonLoadMore)`
  padding: 20px 0 10px 0;

  @media (max-width: 800px) {
    padding: 0px;
  }
`;
